export const CHECKOUT = 'checkout-id'